module.exports = __webpack_public_path__ + "static/media/hessam.354914a9.svg";